// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"198":"18e0d7b1","206":"df822f36","453":"04f120a9","502":"3fe665e4","518":"6b4638f6","606":"3d32ad52","858":"8196abe7","908":"1d349f9d"}[chunkId] + ".chunk.css";
};